export enum TechnicalPointCategory {
  SWAP_POINT = 'swap-point',
  DELEGATION = 'delegation',
}
